var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-video-component"},[_c('VideoAdd',{attrs:{"max-files":1},model:{value:(_vm.videos),callback:function ($$v) {_vm.videos=$$v},expression:"videos"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }